import { UniqueIdentifier } from '@dnd-kit/core';
import { useEffect } from 'react';
import { validateLang } from '../../../../../helpers/lang';
import { validate } from '../../../../../helpers/validate';
import { useLang } from '../../../../../hooks/use-lang';
import { useModalParams } from '../../../../../hooks/use-modal-params';
import { useQueryParams } from '../../../../../hooks/use-query-params';
import { useFormStore } from '../../../../../store/use-form-store';
import { useInputLangStore } from '../../../../../store/use-input-lang-store';

export const useCreateForm = () => {
  const { t, getLocale } = useLang();
  const params = useQueryParams().getQueryParams();
  const id = params.id;
  const { language } = useInputLangStore();
  const { form, handleUpdateForm, handleResetForm, postForm, putForm, fetchForm } = useFormStore();
  const createElementModal = useModalParams('createFormElement');

  useEffect(() => {
    if (id) fetchForm(id);
    return () => handleResetForm();
  }, []);

  const handleSort = (e: UniqueIdentifier[]) => {
    const sorted = form?.elements?.sort((a, b) => {
      const aIndex = e.indexOf(a.uuid!);
      const bIndex = e.indexOf(b.uuid!);

      if (aIndex < bIndex) {
        return -1;
      }
      if (aIndex > bIndex) {
        return 1;
      }
      return 0;
    });
    handleUpdateForm({ elements: sorted?.map((item, index) => ({ ...item, order: index })) });
  };

  const handleDeleteElement = (id: string) => {
    const updatedElements = form?.elements?.filter((item) => item.uuid !== id);
    handleUpdateForm({ elements: updatedElements });
  };

  const handleCreate = async () => {
    const isValid = validate({ name: { rule: () => validateLang(form?.name) } });
    if (!isValid) return;

    try {
      if (id) {
        await putForm();
      } else {
        await postForm();
      }
      window.history.back();
    } catch (e) {
      console.error(e);
    }
  };

  return {
    t,
    getLocale,
    id,
    form,
    handleUpdateForm,
    createElementModal,
    handleSort,
    handleDeleteElement,
    handleCreate,
    language,
  };
};
